import { useLayoutEffect } from "react";

export function useResizeObserver<T extends React.RefObject<HTMLElement>>(
  target: T,
  cb: (entries: ResizeObserverEntry[]) => any
) {
  // observe when browser is resizing
  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => cb(entries));
    target.current && resizeObserver.observe(target.current);
    return () => resizeObserver.disconnect();
  }, [target, cb]);
}
